<template>
  <section>
    <figure>
      <a :href="mapHref">
        <img :src="mapImg" alt="" />
      </a>
    </figure>
    <article>
      <div>
        <h3>营业时间</h3>
        <p>{{ city.openTime }}-{{ city.closeTime }}</p>
      </div>
      <div>
        <h3>经营产品</h3>
        <p>{{ city.product }}</p>
      </div>
      <div>
        <h3>电话</h3>
        <p>
          <a :href="`tel:${city.phone}`" class="tel">{{ city.phone }}</a>
        </p>
      </div>
      <div>
        <h3>地址</h3>
        <p>
          <a :href="mapHref">{{ city.address }}</a>
        </p>
      </div>
      <!--<div>-->
      <!--<h3>附近交通</h3>-->
      <!--<p>苏州绿宝广场公交车站: 302路 303路 304路 322路 324路-->
      <!--327路 329路 333路 333路龙池专线 42路 443路 51路 67路-->
      <!--报关报检专2线 地铁一号线： 塔园路站3号口向西步行约940米</p>-->
      <!--</div>-->
    </article>
  </section>
</template>

<script>
import store from "@/store";
export default {
  name: "wit-details",
  data() {
    return {
      city: {
        address: "",
      },
    };
  },
  computed: {
    mapImg() {
      return `https://api.map.baidu.com/staticimage/v2?ak=M21FAKr9KuKPcWVWkZcEgMDh9mgliorz&center=${this.formatGps(
        this.city.gps
      )}&width=512&height=400&zoom=14&markers=${this.formatGps(
        this.city.gps
      )}&copyright=1`;
    },
    mapHref() {
      return `https://map.baidu.com/mobile/webapp/search/search/qt=s&wd=${this.city.address}&vt=map/traffic=on`;
    },
  },
  methods: {
    formatGps(gps) {
      let arr = gps.split(",");
      return arr[1] + "," + arr[0];
    },
  },
  store,
  created() {
    // let city = window.sessionStorage.getItem("cityData");
    let shopTypeData = this.$store.state.shopTypeData;
    const shopType = this.$route.query.shopType;
    const id = this.$route.query.id;
    console.log({
      shopTypeData,
      shopType,
      id
    });
    if (shopTypeData !== null && id !== undefined && shopType !== undefined) {
      this.city = shopTypeData[shopType].storeList.shopList[id]; 
    } else {
      this.$router.push("/");
    }
    // if (city && /^\d{0,3}$/.test(this.$route.query.id)) {
    //   this.city = JSON.parse(city)[this.$route.query.id];
    // } else {
    //   this.$router.push("/");
    // }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/global.scss";
section {
  width: 100%;
  height: 100%;
  background: #ffffff;
}
figure {
  img {
    display: block;
    width: 100%;
    //height: (606rem/$base);
  }
}
article {
  background: $color-bg-b;
  > div {
    & + div {
      border-top: (1rem / $base) solid #eee;
    }
    padding: (40rem / $base) (24rem / $base);
    margin: 0 (20rem / $base);
    h3 {
      font-size: (28rem / $base);
      font-weight: bold;
    }
    p {
      margin-top: (12rem / $base);
      color: #666666;
      font-size: (24rem / $base);
    }
    .tel {
      color: #ec6941;
      font-weight: bold;
    }
  }
}
</style>
